import { useCenterStat, useCenters } from "../../../hooks/centers.hooks";
import { useCommandsStatusStats } from "../../../hooks/stats.hooks";
import { useConnectedUser } from "../../../hooks/user.hooks";
import { useOrdersKanbanStore } from "../../../stores/kanban.store";
import { CommandStatus } from "../../../types/command.types";
import { Button, Flex } from "@chakra-ui/react";

type Props = {
	status?: CommandStatus;
	setStatus: (status?: CommandStatus) => void;
	setNotStatus: (status?: CommandStatus) => void;
};

const OrdersDraftStatusFilter = ({
	status,
	setStatus,
	setNotStatus,
}: Props) => {
	const user = useConnectedUser();
	const { center } = useCenters();
	const {
		filters: { centerId },
	} = useOrdersKanbanStore();
	const centerStatsId = user?.isSuperAdmin ? centerId : center?.id;
	const { data: centerStats } = useCenterStat(centerStatsId);
	const { data: commandStatusStats } = useCommandsStatusStats({});
	const hasDraftFilter = status === CommandStatus.DRAFT;
	const count = user?.isSuperAdmin
		? centerId
			? centerStats?.commandsDraftCount
			: commandStatusStats?.[CommandStatus.DRAFT]
		: centerStats?.commandsDraftCount;

	const handleToggle = () => {
		if (hasDraftFilter) {
			setStatus(undefined);
			setNotStatus(CommandStatus.DRAFT);
		} else {
			setStatus(CommandStatus.DRAFT);
			setNotStatus(undefined);
		}
	};

	return (
		<Flex pl={4}>
			{count !== undefined && (
				<Button
					variant="link"
					color="brand.700"
					backgroundColor={hasDraftFilter ? "brand.50" : undefined}
					onClick={handleToggle}
					px={4}
				>
					Brouillons&nbsp;<span>({count})</span>
				</Button>
			)}
		</Flex>
	);
};

export default OrdersDraftStatusFilter;
